import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const logoHeaderTextFn = /* @__PURE__ */ createRecipe('logo-header-text', {}, [])

const logoHeaderTextVariantMap = {}

const logoHeaderTextVariantKeys = Object.keys(logoHeaderTextVariantMap)

export const logoHeaderText = /* @__PURE__ */ Object.assign(memo(logoHeaderTextFn.recipeFn), {
  __recipe__: true,
  __name__: 'logoHeaderText',
  __getCompoundVariantCss__: logoHeaderTextFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: logoHeaderTextVariantKeys,
  variantMap: logoHeaderTextVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, logoHeaderTextVariantKeys)
  },
  getVariantProps: logoHeaderTextFn.getVariantProps,
})